import type { AdminApiCredentialListFilters } from '@/api/models';

/** Count of active API-credential-list filters, for the `FiltersPopover` badge. Excludes pagination. */
export function countActiveCredentialFilters(filters: AdminApiCredentialListFilters): number {
  return [filters.applicationCode?.length].filter((value) => Boolean(value)).length;
}
